<template>
    <div class="People">
        <div class="row record-section-row">
            <div class="col">
                <h4>Pastor:</h4>
                <div>
                    <BasicPersonDisplayAndEdit :edit-mode="EditMode"
                                               :global-update="false"
                                               get-endpoint="StrongFamilies/Churches/ChurchContacts"
                                               :get-payload="{ChurchID: RecordData.Id, Category: 'Pastor'}"
                                               create-update-endpoint="StrongFamilies/Churches/ChurchContacts"
                                               :create-update-payload="{ChurchID: RecordData.Id, Category: 'Pastor'}"
                                               delete-endpoint="StrongFamilies/Churches/ChurchContacts" 
                                               :is-church-contact="true" />
                </div>
            </div>
        </div>
        <div class="row record-section-row">
            <div class="col">
                <h4>Ministry Lead:</h4>
                <div>
                    <BasicPersonDisplayAndEdit :edit-mode="EditMode"
                                               :global-update="false"
                                               get-endpoint="StrongFamilies/Churches/ChurchContacts"
                                               :get-payload="{ChurchID: RecordData.Id, Category: 'Ministry Lead'}"
                                               create-update-endpoint="StrongFamilies/Churches/ChurchContacts"
                                               :create-update-payload="{ChurchID: RecordData.Id, Category: 'Ministry Lead'}"
                                               delete-endpoint="StrongFamilies/Churches/ChurchContacts" 
                                               :is-church-contact="true" />
                </div>
            </div>
        </div>
        <div class="row record-section-row">
            <div class="col">
                <h4>Family Coaches:</h4>
                <div>
                    <BasicPersonDisplayAndEdit :edit-mode="EditMode"
                                               :global-update="false"
                                               get-endpoint="StrongFamilies/Churches/ChurchContacts"
                                               :get-payload="{ChurchID: RecordData.Id, Category: 'Family Coach'}"
                                               create-update-endpoint="StrongFamilies/Churches/ChurchContacts"
                                               :create-update-payload="{ChurchID: RecordData.Id, Category: 'Family Coach'}"
                                               delete-endpoint="StrongFamilies/Churches/ChurchContacts" 
                                               :is-church-contact="true" />
                </div>
            </div>
        </div>
        <div class="row record-section-row">
            <div class="col">
                <h4>Other Staff:</h4>
                <div>
                    <BasicPersonDisplayAndEdit :edit-mode="EditMode"
                                               :global-update="false"
                                               get-endpoint="StrongFamilies/Churches/ChurchContacts"
                                               :get-payload="{ChurchID: RecordData.Id, Category: 'Other Staff'}"
                                               create-update-endpoint="StrongFamilies/Churches/ChurchContacts"
                                               :create-update-payload="{ChurchID: RecordData.Id, Category: 'Other Staff'}"
                                               delete-endpoint="StrongFamilies/Churches/ChurchContacts" 
                                               :is-church-contact="true" />
                </div>
            </div>
        </div>
        <div class="row record-section-row">
            <div class="col">
                <h4>Volunteer Families:</h4>
                <div>
                    <b-container>
                        <b-row style="overflow-x:auto;">
                            <b-col cols="11">
                                <vuetable :fields="FamilyMemberFields"
                                          :data="RecordData.FosterResourceFamilies"
                                          pagination-path=""
                                          :api-mode="false"
                                          class="vue-datatable">
                                </vuetable>
                            </b-col>
                        </b-row>
                    </b-container>
                </div>
            </div>
        </div>
        <EditMode :EditMode="EditMode" @update-edit-mode="UpdateEditMode" permission="StrongFamiliesModuleGeneral" />
    </div>
</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    //import components
    import Vuetable from 'vuetable-2/src/components/Vuetable';
    import BasicPersonDisplayAndEdit from '../../../../Core/ItemEditors/BasicPersonDisplayAndEdit.vue';
    import EditMode from '../../../../Core/ItemEditors/EditMode.vue';
    export default {
        props: [
            'RecordData'
        ],
        data: function () {
            return {
                EditMode: false,
                FamilyMemberFields: [
                    {
                        name: 'FosterResourceFamily.Name',
                        title: 'NAME',
                    },
                    {
                        name: 'MembershipType',
                        title: 'ASSOCIATION TYPE',
                    },
                    {
                        name: 'FosterResourceFamily.StrongFamiliesCategories',
                        title: 'VOLUNTEER TYPE'
                    },
                ]
            };
        },
        methods: {
            formatDate(value, fmt = 'MM/DD/YY', defaultText = '') {
                return (value == null)
                    ? defaultText
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
            UpdateEditMode() {
                this.EditMode = !this.EditMode;
            }
        },
        components: {
            BasicPersonDisplayAndEdit,
            EditMode,
            Vuetable
        },
        mounted() {

        },
        computed: {

        }    
    }
</script>

<style scoped>
</style>